import _throttle from 'lodash/throttle'
import store from '@/vuex/store'
import EventBus from '@/eventBus'
import Constants from '@/constant'

const MESSAGE_TYPES = {
  ANSWER_GROUP: 'quiz-group-answer',
  AUDIENCE_ANSWERED: 'q-aa',
}

const logData = {}

const _checkEveryoneVotedQuiz = () => {
  if (store.state.slideActive.type !== 'pickAnswer') {
    return
  }
  if (store.state.slideActive.quizStatus !== Constants.QuizStatuses.QUESTION_SCREEN) {
    return
  }

  let someoneHaveNotVote = false

  Object.keys(store.state.audiences).forEach((key) => {
    const audience = store.state.audiences[key]
    const audienceNotAnswer = !audience[store.state.slideActive.id]
    if (audienceNotAnswer) {
      someoneHaveNotVote = true
    }
  })
  if (!someoneHaveNotVote && !store.getters['featureToggles/canUseEveryoneHasAnswered']) {
    EventBus.$emit('everyone-voted')
  }
}

function handleParticipantAnswered(doc) {
  doc = doc.data
  if (!store.state.sharePresentation && store.state.slideActive.type == 'pickAnswer') {
    if (store.state.userOnline < 30) {
      if (store.state.audiences[doc.a]) {
        store.state.audiences[doc.a][doc.s] = true
        _checkEveryoneVotedQuiz()
      }
    }
  }
}

const updateVoteCount = () => {
  const payload = {
    multipleCountAnswer: store.state.slideActive.countBackup,
  }
  store.dispatch('updateSlideActiveAction', payload)
  if (store.state.presentation.audiencePacing) {
    // update chart whenever audience answers
    store.dispatch('updateSlideActive', store.state.slideActive)
  }
}

const updateVoteCountThrottle = _throttle(updateVoteCount, 250)

const updateCountSlideOption = (slideOptionId, slide, count) => {
  slideOptionId = parseInt(slideOptionId, 10)
  slide.SlideOptions.forEach((slideOption) => {
    if (slideOption.id === slideOptionId) {
      slideOption.count += count
    }
  })
}

const handleAnswerGroup = (doc) => {
  const { slideId, data, voteCount } = doc.data
  let count = 0

  Object.keys(data).forEach((key) => {
    if (!logData[key]) {
      logData[key] = {
        count: 0,
      }
    }
    if (!data[key].count) data[key].count = 0
    logData[key].count += data[key].count
  })
  if (store.state.slideActive && store.state.slideActive.id === slideId) {
    Object.keys(logData).forEach((key) => {
      if (!logData[key].count) logData[key].count = 0
      count += logData[key].count
      updateCountSlideOption(key, store.state.slideActive, logData[key].count)
      logData[key].count = 0
    })
    if (!store.state.slideActive.countBackup) {
      const countBackup = store.state.slideActive.multipleCountAnswer || 0
      store.state.slideActive.countBackup = countBackup
    }
    store.state.slideActive.countBackup += voteCount

    updateVoteCountThrottle()
  } else {
    store.state.presentation.slides.forEach((slide) => {
      if (slide.id !== slideId) {
        slide.multipleCountAnswer += count
        Object.keys(logData).forEach((key) => {
          count += logData[key].count
          updateCountSlideOption(key, slide, logData[key].count)
          logData[key].count = 0
        })
      }
    })
  }
}

const AnswerWebsocketSubscriber = {
  [MESSAGE_TYPES.ANSWER_GROUP]: handleAnswerGroup,
  [MESSAGE_TYPES.AUDIENCE_ANSWERED]: handleParticipantAnswered,
}

export default AnswerWebsocketSubscriber
